var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"psui-w-full psui-h-full psui-min-h-screen psui-flex psui-flex-col psui-overflow-y-auto"},[_c('router-view'),_c('ModalJurisdictionSelection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }